import ExportWorkflow from '../../../../components/workflows/general/export-workflow';

angular
    .module('festzelt-os.contacts')
    .factory('exportContacts', [
        'Alert',
        '$http',
        '$uibModal',
        '$translate',
        (Alert, $http, $uibModal, $translate) => new ExportWorkflow('contacts', Alert, $http, $uibModal, $translate)
    ])



// WEBPACK FOOTER //
// ./src/app/pages/contacts/workflows/list-view/export-contacts.js